export default __webpack_public_path__ + "static/media/IMG_9951.2ebd6c49.jpeg";